export default __webpack_public_path__ + "static/media/new-verified-logo.f795012e.jpeg";